import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import { Modal, Message, Loader } from 'semantic-ui-react';
import ReactJson from 'react-json-view';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../model/context/app/app';
import { api } from '../../services/fetch/api';
import { useParams } from 'react-router-dom';
import { ModalProps } from '../../types/ModalProps';

export const IdNowModalComponent: FunctionComponent<ModalProps> = ({ showModal = false, onClose }) => {
    const { t } = useTranslation();

    const [loading, setLoading] = useState(true);
    const [idNowProcessStarted, setIdNowProcessStarted] = useState(false);
    const [idNowResponse, setIdNowResponse] = useState({});
    const context = useContext(AppContext);
    const { leadId } = useParams();

    async function fetchIDnowStatus() {
        setLoading(true);
        const resp = await fetch(`${api.identificationDetails}/${leadId}`, {
            method: 'GET',
            headers: {
                'Accept-Language': 'de-DE',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${context.token}`,
            },
        });
        if (resp.status === 200) {
            setIdNowResponse(await resp.json());
            setIdNowProcessStarted(true);
        } else {
            setIdNowResponse({});
        }
        setLoading(false);
    }

    useEffect(() => {
        if (showModal) {
            fetchIDnowStatus();
        }
    }, [showModal]);

    return (
        <Modal open={showModal} size={'large'} closeOnEscape={true} closeOnTriggerBlur={true} onClose={onClose}>
            <Modal.Header>{t('lead.detail.box.idNow.headline')}</Modal.Header>
            {loading && <Loader active={loading} />}
            {!loading && (
                <Modal.Content scrolling={true}>
                    {idNowProcessStarted ? (
                        <ReactJson src={idNowResponse} displayDataTypes={false}></ReactJson>
                    ) : (
                        <Message warning>
                            <Message.Header>{t('lead.detail.box.idNow.infoHeadline')}</Message.Header>
                            <p>{t('lead.detail.box.idNow.infoText')}</p>
                        </Message>
                    )}
                </Modal.Content>
            )}
        </Modal>
    );
};
